import { ReporingImageActionTypes, ReportingImageAction, ReportingImageState } from "./types";

const initialState: ReportingImageState = {
    count: 0,
    reportingImages: [],
}

export const reportingImageReducer = (state = initialState, action: ReportingImageAction): ReportingImageState => {
    switch (action.type) {
        case ReporingImageActionTypes.SEARCH_REPORTING_IMAGES:
            return {
                ...state,
                count: action.payload.count,
                reportingImages: action.payload.values,
            }
        default:
            return state;
    }
}